import ReportComponent from "../components/report.component";

const ReportScreen = () => {
  return <ReportComponent />;
};

export default ReportScreen;
